/**
 * Identity vocabularies the server posts and compares, mirrored from C# and pinned against it by
 * MagicStringConventionTests: RoleNames ↔ Procuidado.Data/Constants/RoleNames.cs, UserTypes ↔ the
 * UserType enum (Procuidado.Data/Entities/ApplicationUser.cs).
 */
export const RoleNames = Object.freeze({
  Caregiver: "Caregiver",
  Customer: "Customer",
  Administrator: "Administrator",
  BackofficeManager: "BackofficeManager",
});

export const UserTypes = Object.freeze({
  Caregiver: "Caregiver",
  Customer: "Customer",
  BackofficeUser: "BackofficeUser",
});
